/*!
  Pioneer WFRIA TabsUtility v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["TabsUtility"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("TabsUtility") < 0) {
    window.__PIONEER_GLOBAL__.components.push("TabsUtility");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

/**
 * getPreviousTabIndex method will return previous index of the tab item to be pulled into the viewport
 * based on index
 * @param  {Number} left
 * @param  {Node} tabsNavBarInner
 * @return {Number}
 */
export function getPreviousTabIndex(left, tabsNavBarInner) {
  let startX = 0,
      endX,
      index,
      currentTab,
      newIndex = tabsNavBarInner.childElementCount - 1;
  const length = tabsNavBarInner.childElementCount;
  const leftDistance = left || 0;
  const leftAdjustment = -1 * leftDistance;

  if (leftAdjustment > 0) {
    for (index = 0; index < length; index++) {
      currentTab = tabsNavBarInner.children[index];
      startX = currentTab.offsetLeft;
      endX = startX + currentTab.offsetWidth;
      /**
       * this condition will execute for each tab and
       * will get index of tab which should come into view port
       */

      if (endX <= leftAdjustment) {
        newIndex = index;
      } else if (startX < leftAdjustment) {
        newIndex = index;
        break;
      } else {
        break;
      }
    }
  }

  return newIndex;
}
/**
 * getNextTabIndex method will return next index of the tab item to be pulled into the viewport
 * based on index
 * @param  {Number} left
 * @param  {Node} tabsNavBarInner
 * @param  {Number} containerWidth
 * @param  {Number} listWidth
 * @return {Number}
 */

export function getNextTabIndex(left, tabsNavBarInner, containerWidth, listWidth) {
  let startX = 0,
      endX,
      index,
      currentTab,
      newIndex = 0;
  const length = tabsNavBarInner.childElementCount;
  const leftDistance = left || 0;
  /**
   * Tabs container width + left position value of left side hidden tab's
   * is stored in the leftAdjustment.
   */

  const leftAdjustment = containerWidth - leftDistance;

  if (leftAdjustment < listWidth) {
    for (index = 0; index < length; index++) {
      currentTab = tabsNavBarInner.children[index];
      startX = currentTab.offsetLeft;
      endX = startX + currentTab.offsetWidth;
      /**
       * On click of the next button, this condition checks whether the leftAdjustment value
       * is less than the each tab's starting left distance(startX) or
       * greater than each tab 's ending left distance,
       * if so, then break the loop and return the index of the tab to be shown.
       */

      if (startX > leftAdjustment || leftAdjustment < endX) {
        newIndex = index;
        break;
      }
    }
  }

  return newIndex;
}
/**
 * getLeftOffset method will calculate the left value to move the Tabs and
 * to show tab items which are not in view port
 * @param  {Number} currentSelected
 * @param  {Number} tabsNavBarOuterWidth
 * @param  {Number} tabsNavBarInnerWidth
 * @param  {Node} tabsNavBarInner
 * @return {Number}
 */
// eslint-disable-next-line max-params

export function getLeftOffset(currentSelected, tabsNavBarOuterWidth, tabsNavBarInnerWidth, tabsNavBarInner) {
  let newLeft;
  const absoluteVal = Math.abs;
  const currentSelectedTab = tabsNavBarInner.children[currentSelected];
  const {
    offsetLeft,
    offsetWidth
  } = currentSelectedTab; // selectedTab left

  const minLeft = -1 * offsetLeft; // selectedTab right

  const minRight = -1 * (offsetLeft + offsetWidth); // max possible left

  const maxLeft = tabsNavBarOuterWidth - tabsNavBarInnerWidth;
  const currentLeft = parseFloat(tabsNavBarInner.style.left);

  if (currentLeft < maxLeft) {
    newLeft = maxLeft;
  } else {
    newLeft = currentLeft;
  }

  const newRightEnd = absoluteVal(newLeft - tabsNavBarOuterWidth);
  /**
   * If condition is setting newLeft value for following cases:
   * * when the selected tab is on left side and not in the viewport.
   * * when we move from last tab to the first tab.
   * Else-If condition is setting newLeft value for following cases:
   * * when the selected tab is on right side and not in the viewport.
   * * when we move from first tab to the last tab.
   */

  if (absoluteVal(minLeft) < absoluteVal(newLeft) && absoluteVal(minRight) >= absoluteVal(newLeft) || absoluteVal(minRight) < absoluteVal(newLeft)) {
    // align focused on left edge
    newLeft = minLeft;
  } else if (absoluteVal(minLeft) <= absoluteVal(newRightEnd) && absoluteVal(newRightEnd) < absoluteVal(minRight) || absoluteVal(newRightEnd) < absoluteVal(minLeft)) {
    newLeft = minRight + tabsNavBarOuterWidth;
  }

  return newLeft;
}